export default __webpack_public_path__ + "static/media/logo.19ed7c8a.png";